import moment from "moment";
import React, { useState, useEffect, useMemo } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { withRouter, useLocation } from "react-router-dom";
import { config } from "../../../../../../../config";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { messages } from "../../../../../../../messages";
import WarningDialogue from '../../../../../../../Util/WarningDialogue';

function TeamStandings() {
  const [teams, setTeams] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [leagueId, setLeagueId] = useState(0);
  const search = useLocation().search;
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [disableDrag, setDisableDrag] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const [disableReason, setDisableReason] = useState({
    single: '',
    divisions: {},
  });
  useEffect(() => {
    const leagueId_ = new URLSearchParams(search).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, [leagueId]);

  useEffect(async () => {
    if (leagueId) {
      try {
        getStandingInfo();
      } catch (e) {
        console.log('error', e)
      }
    }
    // eslint-disable-next-line
  }, [leagueId]);

  const getStandingInfo = async () => {
    let divisions = [];
    const resp1 = await getLeagueDivision();
    if (resp1.data?.data) {
      divisions = resp1.data.data?.divisions || [];

      if (Array.isArray(resp1.data.data?.teams) && resp1.data.data?.teams.length > 0 && Array.isArray(resp1.data.data?.divisions) && resp1.data.data?.divisions.length > 0) {

        resp1.data.data?.divisions.forEach((val) => {
          const teamIds = val.team_ids.split(',').map(x => +x);
          val.team_ids = resp1.data.data?.teams.filter(x => teamIds.includes(x.id)).map(y => y.id).join(',');
          val.disableDrag = true;
          val.change = false;
          val.prevRanking = val.team_ids;
        });
      }
      setDivisions(resp1.data.data?.divisions || []);
      setTeams(resp1.data.data?.teams || []);
    }

    // Check if user can change standing 
    // Team Standing can't not be update if regular match are not complete or any playoff match was played before current date 
    const resp = await getRegularSeasonStatus();
    if (resp?.data?.data) {

      const firstPlayOffMatch = resp?.data?.data?.firstPlayOffMatch || [];
      const tempReason = { ...disableReason };
      if (divisions.length > 0) {
        const divisionStatus = resp?.data?.data?.divisionStatus || [];
        const temp = [...divisions];
        temp.forEach(division => {
          const find = divisionStatus.find(x => +x.id === +division.id);
          division.disableDrag = find ? !find.seasonCompleted : false;
          tempReason.divisions[division.id] = '';

          // Error message
          if (division.disableDrag) {
            tempReason.divisions[division.id] = messages.regularDivisionSeason;
          }

          const matchDate = firstPlayOffMatch.find(x => +x.division_id === +division.id);
          if (matchDate && matchDate.date && !division.disableDrag) {
            division.disableDrag = moment(matchDate.date).isBefore(new Date()) ? true : false;

            // Error message
            if (division.disableDrag) {
              tempReason.divisions[division.id] = messages.playoffStarted;
            }
          }
          setDisableReason(tempReason);
        });
        setDivisions(temp);
      } else {
        let notDragable = resp.data.data.seasonCompleted ? false : true;
        if (notDragable) {
          setDisableReason((prev) => ({ ...prev, single: messages.regularSeason }));
        }
        const matchDate = firstPlayOffMatch.length > 0 ? firstPlayOffMatch[0] : [];
        if (matchDate && matchDate.date && !notDragable) {
          notDragable = moment(matchDate.date).isBefore(new Date()) ? true : false;
          if (notDragable) {
            setDisableReason((prev) => ({ ...prev, single: messages.playoffStarted }));
          }
        }
        setDisableDrag(notDragable);
      }
    }
  }
  function getLeagueDivision() {
    return axiosApi.get(`${config.apiUrl}/leagues/league-division/${leagueId}`);
  }

  const getRegularSeasonStatus = () => {
    return axiosApi.get(`${config.apiUrl}/leagues/check-regular-season/${leagueId}`);
  }

  const getWinPercentage = (team) => {
    if (!isNaN(team.win_count) && !isNaN(team.loss_count) && !isNaN(team.tie_count)) {
      const totalMatch = +team.win_count + +team.loss_count + +team.tie_count;
      if (totalMatch) {
        const percentage = (team.win_count / totalMatch).toFixed(2);
        return +percentage;
      }
    }
    return 0;
  }

  /**
   * Drag n Drop
   */
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index === result.source.index) {
      return;
    }
    const allTeams = reorder(
      teams,
      result.source.index,
      result.destination.index
    );
    setTeams(allTeams);
    setShowButton(true);
  };

  const onDivisionDragEnd = (result, a, idx) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;
    if (source.droppableId === destination.droppableId) {
      const temp = [...divisions];
      const tmp = temp[idx].team_ids.split(',');
      const teamOrder = [reorder(tmp, source.index, destination.index)];
      temp[idx].team_ids = teamOrder.toString();
      temp[idx].change = true;
      setDivisions(temp);
    }
  };

  function Team({ data, idx }) {
    return (
      <Draggable key={data.id} draggableId={data.id} index={+idx}>
        {(provided, snapshot) => (
          <div className="div-card-item"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className="div-card-td div-cell-pos">1st</div>
            <div className="div-card-td div-cell-team">{data.name}</div>
            <div className="div-card-td div-cell-win">{data?.win_count || 0}</div>
            <div className="div-card-td div-cell-loss">{data?.loss_count || 0}</div>
            <div className="div-card-td div-cell-ties">{data?.tie_count || 0}</div>
            <div className="div-card-td div-cell-win-per">{getWinPercentage(data)}</div>
          </div>
        )}
      </Draggable>
    )
  }

  const TeamList = React.memo(function TeamList({ teams }) {
    return <>
      <div className="div-card-body">
        <div className="div-card-items">
          {
            teams.length ? teams.map((team, i) => (
              <Team data={team} index={i} key={team.id} />
            )) : <></>
          }
        </div>
      </div>
    </>
  });
  /**
   * Drag n Drop end
   */
  function mapTeam(array, order, key) {
    array.sort(function (a, b) {
      var A = a[key], B = b[key];
      if (order.indexOf(A.toString()) > order.indexOf(B.toString())) {
        return 1;
      } else {
        return -1;
      }

    });
    return array;
  };

  const getDivisionByOrder = (division) => {
    let results = Array.isArray(teams) && teams.length ?
      teams.filter((team) => (division?.team_ids || '').split(',')
        .map(teams_id => Number(teams_id)).includes(team.id)) : [];
    const temp = division?.team_ids.split(',');
    results = mapTeam(results, temp, 'id');

    if (results && results.length) {
      return (
        <div className="div-card-body">
          <div className="div-card-items">
            {
              results.map((team_, i) => (
                <Draggable key={team_.id} divisionData={division} isDragDisabled={division.disableDrag} draggableId={(team_.id).toString()} index={+i}>
                  {(provided, snapshot) => (
                    <div className="div-card-item"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className="div-card-td div-cell-pos">{
                        (function (rank) {
                          rank = (i + 1).toString();
                          const idx = (rank.length - 1);
                          if (idx >= 0) {
                            if (Number(rank[idx]) === 1) {
                              return rank + 'st';
                            } else if (Number(rank[idx]) === 2) {
                              return rank + 'nd';
                            } else if (Number(rank[idx]) === 3) {
                              return rank + 'rd';
                            } else {
                              return rank + 'th';
                            }
                          }
                        }(i))
                      }</div>
                      <div className="div-card-td div-cell-team">{team_.name}</div>
                      <div className="div-card-td div-cell-win">{team_?.win_count || 0}</div>
                      <div className="div-card-td div-cell-loss">{team_?.loss_count || 0}</div>
                      <div className="div-card-td div-cell-ties">{team_?.tie_count || 0}</div>
                      <div className="div-card-td div-cell-win-per">{getWinPercentage(team_)}</div>
                    </div>
                  )}
                </Draggable>
              ))
            }
          </div>
        </div>
      );
    } else {
      return (
        <tr>
          <td colSpan={6}></td>
        </tr>
      )
    }
  }

  const getLeagueStandings = () => {
    const results = teams;
    if (results && results.length) {
      return (
        <div className="div-card-body">
          <div className="div-card-items">
            {results.map((team_, i) => (
              <Draggable key={team_.id} draggableId={(team_.id).toString()} index={+i} isDragDisabled={disableDrag}>
                {(provided, snapshot) => (
                  <div className="div-card-item"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <div className="div-card-td div-cell-pos">{
                      (function (rank) {
                        rank = (i + 1).toString();
                        const idx = (rank.length - 1);
                        if (idx >= 0) {
                          if (Number(rank[idx]) === 1) {
                            return rank + 'st';
                          } else if (Number(rank[idx]) === 2) {
                            return rank + 'nd';
                          } else if (Number(rank[idx]) === 3) {
                            return rank + 'rd';
                          } else {
                            return rank + 'th';
                          }
                        }
                      }(i))
                    }</div>
                    <div className="div-card-td div-cell-team">{team_.name}</div>
                    <div className="div-card-td div-cell-win">{team_?.win_count || 0}</div>
                    <div className="div-card-td div-cell-loss">{team_?.loss_count || 0}</div>
                    <div className="div-card-td div-cell-ties">{team_?.tie_count || 0}</div>
                    <div className="div-card-td div-cell-win-per">{getWinPercentage(team_)}</div>
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <tr>
          <td colSpan={6}>No Teams</td>
        </tr>
      )
    }
  }

  const saveStanding = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: 'Would you like to update this standings?',
      action: () => {
        axiosApi.post(`${config.apiUrl}/leagues/save-standings/`, {
          teams: teams,
          divisions: Array.isArray(divisions) && divisions.length > 0 ? divisions : [],
          id: leagueId,
        })
          .then((response) => {
            setOpenWarningPopup(false);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }

  const saveDivisionStanding = (division) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: 'Would you like to update this standings?',
      action: () => {
        axiosApi.post(`${config.apiUrl}/leagues/save-standings/`, {
          division,
          id: leagueId,
        })
          .then((response) => {
            setOpenWarningPopup(false);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }
  const resetStandings = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: 'Would you like to reset standings?',
      action: () => {
        axiosApi.get(`${config.apiUrl}/leagues/reset-standings/${leagueId}`)
          .then((response) => {
            if (response?.data?.data) {
              setTeams(response?.data?.data);
            }
            setOpenWarningPopup(false);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }

  const resetDivision = (division) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: 'Would you like to reset standings?',
      action: () => {
        axiosApi.get(`${config.apiUrl}/leagues/reset-division-standings/${leagueId}/${division.id}`)
          .then((response) => {
            getStandingInfo();
            setOpenWarningPopup(false);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }

  const showError = (type, division) => {
    console.log('--type--', type);
    if (type === 'no-division') {
      if (disableDrag) {
        setOpenWarningPopup(true);
        setPopUpContent({
          header: 'Warning',
          description: disableReason.single,
          action: () => {
            setOpenWarningPopup(false);
          },
          messageOnly: true,
          button: 'Ok',
        });
      }
    } else {
      if (division && division.disableDrag) {
        setOpenWarningPopup(true);
        setPopUpContent({
          header: 'Warning',
          description: disableReason?.divisions[division.id] || messages.playoffStarted,
          action: () => {
            setOpenWarningPopup(false);
          },
          messageOnly: true,
          button: 'Ok',
        });
      }
    }
  }
  return <>
    {
      !divisions?.length && teams.length > 0 && <div className="action-section">
        {
          showButton &&
          <button className="btn btn-primary" onClick={() => saveStanding()}>Save Standing</button>
        }

        <button className="btn btn-primary" onClick={() => resetStandings()}>Reset Standing</button>
      </div>
    }

    <div className="division-cards">
      {
        Array.isArray(divisions) && divisions.length ?
          divisions.map((division, key) => <DragDropContext onDragEnd={(e) => onDivisionDragEnd(e, division, key)} key={key} >
            <div className="division-card" key={`division-league-${key + 1}`} onClick={() => showError('division', division)}>
              <div className="division-card-name">
                <h4>
                  Division - {division?.name || 'N/A'}
                </h4>
                <div className="action-btn">
                  {
                    !division.disableDrag &&
                    <>
                      {
                        division.change &&
                        <button className="btn btn-primary" onClick={() => saveDivisionStanding(division)}>Save Standing</button>
                      }
                      <button className={`btn btn-primary ${division.change ? 'half' : 'full'}`} onClick={() => resetDivision(division)}>Reset Standing</button>
                    </>
                  }
                </div>
              </div>
              <div className="division-card-header">
                <div className="div-card-th div-cell-pos">Position</div>
                <div className="div-card-th div-cell-team">Team</div>
                <div className="div-card-th div-cell-win">Win</div>
                <div className="div-card-th div-cell-loss">Loss</div>
                <div className="div-card-th div-cell-ties">Ties</div>
                <div className="div-card-th div-cell-win-per">Win %</div>
              </div>

              <Droppable droppableId={`droppable-${key}`} key={key}>
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {getDivisionByOrder(division, key)}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </DragDropContext>)
          :
          <div className="division-card" key={``} onClick={() => showError('no-division')}>
            <div className="division-card-header">
              <div className="div-card-th div-cell-pos">Position</div>
              <div className="div-card-th div-cell-team">Team</div>
              <div className="div-card-th div-cell-win">Win</div>
              <div className="div-card-th div-cell-loss">Loss</div>
              <div className="div-card-th div-cell-ties">Ties</div>
              <div className="div-card-th div-cell-win-per">Win %</div>
            </div>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {getLeagueStandings()}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
      }
    </div >
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popUpContent.header}
      description={popUpContent.description}
      icon={popUpContent.icon}
      action={popUpContent.action}
      confirmButton={popUpContent.button ? popUpContent.button : 'Confirm'}
      messageOnly={popUpContent.messageOnly || false}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}
export default withRouter(TeamStandings);